<template>
  <section>
    <v-dialog
      v-model="dialog"
      scrollable
      lazy
      persistent
      max-width="640"
    >
      <v-card class="c parking-lot-settings">
        <v-card-title>
          <v-layout row wrap class="is-100">
            <v-flex>
              <h3 class="headline">Einstellungen</h3>
            </v-flex>
          </v-layout>
          <v-tabs slot="extension" v-model="tab" color="white"grow>
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab>
              Standortdaten
            </v-tab>
            <v-tab disabled>
              Benachrichtigungen
            </v-tab>
            <v-tab disabled>
              Standard Regeln
            </v-tab>
          </v-tabs>
        </v-card-title>

        <v-card-text style="max-height: 60vh;">
          <div v-show="tab === 2">
            <v-list class="rules-list" two-line subheader>
              <v-subheader>Regeln</v-subheader>
              <v-list-tile class="has-rules" v-for="(rule, index) in settings.rules" :key="`${rule}-${index}`">
                <v-list-tile-content>
                  <rules :data="rule" :index="index" @change="onRuleChange" @delete="onRuleDelete"></rules>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-if="settings.rules.length === 0">
                <v-list-tile-title>Keine Regeln vorhanden.</v-list-tile-title>
              </v-list-tile>
              <v-list-tile>
                <v-btn class="no-spacing" color="primary" outline @click="addRule">Regel hinzufügen</v-btn>
              </v-list-tile>
              <v-divider></v-divider>
              <v-subheader>Ausnahmen</v-subheader>
              <v-list-tile class="has-rules" v-for="(exception, index) in settings.exceptions" :key="`${exception}-exception-${index}`">
                <v-list-tile-content>
                  <exceptions :data="exception" :index="index" @change="onExceptionChange" @delete="onExceptionDelete"></exceptions>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-if="settings.exceptions.length === 0">
                <v-list-tile-title>Keine Ausnahmen vorhanden.</v-list-tile-title>
              </v-list-tile>
              <v-list-tile>
                <v-btn class="no-spacing" color="primary" outline @click="addException">Ausnahme hinzufügen</v-btn>
              </v-list-tile>
            </v-list>
          </div>
          <div v-show="tab === 1">
            <v-list three-line subheader>
              <v-list-tile avatar>
                <v-list-tile-action>
                  <v-switch v-model="settings.notifications.active" color="primary"></v-switch>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Benachrichtigungen</v-list-tile-title>
                  <v-list-tile-sub-title>Lassen sie sich bei Warnungen per E-Mail benachrichtigen</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-if="settings.notifications.active">
                <v-text-field
                  label="E-Mail Adresse*"
                  v-model="settings.notifications.email"
                  type="email"
                  :rules="[rules.email]"
                  :required="settings.notifications.active"
                ></v-text-field>
              </v-list-tile>
              <v-list-tile class="has-rules" v-if="settings.notifications.active">
                <variable-textarea
                  label="Nachrichten Template"
                  v-model="settings.notifications.msgTemplate"
                  :activator="['{']"
                  :variables="variables"
                ></variable-textarea>
              </v-list-tile>
            </v-list>
          </div>
          <div v-show="tab === 0">
            <v-list two-line>
              <v-list-tile>
                <v-text-field
                  label="Name"
                  color="primary"
                  v-model="$store.parkingLots.state.parkingLotDetail.name"
                ></v-text-field>
              </v-list-tile>
              <v-list-tile>
                <v-btn class="no-spacing" color="error" @click="deleteParkingLot">Parkplätz löschen</v-btn>
                <v-btn color="primary" flat @click="updateParkingLotShape">Fläche bearbeiten</v-btn>
              </v-list-tile>
            </v-list>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat="flat" @click="cancel">Abbrechen</v-btn>
          <v-btn color="primary" lat="flat" @click="save">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import Rules from './ParkingLotSettings/Rules.vue';
import Exceptions from './ParkingLotSettings/Exceptions.vue';
import VariableTextarea from '../../basic-components/VariableTextarea.vue';
import notificationHandler from '../../../services/notificationHandler';

export default {
  name: 'parking-lot-settings',

  components: {
    Rules,
    Exceptions,
    VariableTextarea,
  },

  data() {
    return {
      dialog: false,
      alertDialog: false,
      tab: 0,
      settings: {
        notifications: {
          active: false,
          email: '',
          msgTemplate: '',
        },
        rules: [
          {
            dayToggle: ['mo', 'di', 'mi', 'do', 'fr'],
            startTime: 1000,
            endTime: 1800,
            maxTime: 2,
          },
        ],
        exceptions: [],
      },
      variables: ['{{ name }}', '{{ parking_space.id }}', '{{ parking_lot.id }}'],
      rules: {
        email: (v) => {
          if ((v || '').match(/@/)) {
            return true;
          }
          return 'Please enter a valid email';
        },
      },
    };
  },

  watch: {
    dialog() {
      if (!this.dialog) this.$emit('close');
    },
  },

  methods: {
    toggle(bool) {
      if (bool === undefined) this.dialog = !this.dialog;
      else this.dialog = bool;

      if (this.dialog) this.$emit('open');
      else this.$emit('close');
    },
    addRule() {
      this.settings.rules.push({
        dayToggle: [],
        startTime: null,
        endTime: null,
        maxTime: null,
      });
    },
    addException() {
      this.settings.exceptions.push({
        type: 'single_day',
        date: null,
        startTime: null,
        endTime: null,
        maxTime: null,
      });
    },
    onRuleChange(args) {
      this.settings.rules[args.index] = args.data;
    },
    onRuleDelete(args) {
      this.settings.rules.splice(args.index, 1);
    },
    onExceptionChange(args) {
      this.settings.exceptions[args.index] = args.data;
    },
    onExceptionDelete(args) {
      this.settings.exceptions.splice(args.index, 1);
    },
    cancel() {
      this.dialog = false;
    },
    cancelAccept() {
      this.settings = this.oldSettings;
      this.alertDialog = false;
      this.dialog = false;
    },
    save() {
      this.$store.parkingLots.dispatch('PATCH_PARKING_LOT_BY_ID', {
        id: this.$store.parkingLots.state.parkingLotDetail.id,
        payload: {
          name: this.$store.parkingLots.state.parkingLotDetail.name,
        },
      });
      this.dialog = false;
    },
    deleteParkingLot() {
      const validation = prompt(`Schreibe '${this.$store.parkingLots.state.parkingLotDetail.name}' in das Feld`);
      if (validation === this.$store.parkingLots.state.parkingLotDetail.name) {
        notificationHandler.showNotification(`
          ${this.$store.parkingLots.state.parkingLotDetail.name} wurde gelöscht.`, 'snackbar:selfClosed');
        this.$store.parkingLots.dispatch('DELETE_PARKING_LOT', this.$store.parkingLots.state.parkingLotDetail.id)
          .then(() => {
            notificationHandler.showNotification(`
              ${this.$store.parkingLots.state.parkingLotDetail.name} wurde gelöscht.`, 'snackbar:selfClosed');
            this.$router.push('/');
          });
      }
    },
    updateParkingLotShape() {
      this.$emit('update-parking-lot-shape');
    },
  },
};
</script>
